// 🔧 volunteers.js
// ✅ Purpose: Public-facing manager guide for volunteer setup in Let's Go Vote
// ✅ Features:
// - Explains volunteer activities, time slots, signups, and assignments
// - Helps managers organize event staffing needs
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function VolunteersGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
      <SeoHead
        title="Volunteers Guide | Let's Go Vote"
        description="Learn how to organize volunteer activities, time slots, signups, and assignments with Let's Go Vote."
        path="/guides/volunteers"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Guides", path: "/guides" },
          {
            name: "Volunteers",
            path: "/guides/volunteers",
          },
        ]}
      />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">🙋 Volunteers</h1>
          <p className="lead text-muted">
            Organize volunteer opportunities and event staffing needs.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">Volunteers keep events moving</h5>
            <p className="mb-0">
              Let&apos;s Go Vote helps managers create volunteer activities,
              define time slots, invite volunteers, and track assignments.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 1: Create volunteer activities</h3>
          <p>
            Activities describe the type of help needed at your event. Examples
            include check-in table, parking support, voting help desk, setup,
            cleanup, raffle table, auction table, or awards support.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 2: Add time slots</h3>
          <p>
            Time slots define when volunteers are needed. Each activity can have
            one or more time slots, allowing managers to organize coverage
            throughout the event day.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 3: Invite or assign volunteers</h3>
          <p>
            Managers can invite volunteers or assign users to available time
            slots. This helps the event team understand who is helping, when
            they are helping, and where support is still needed.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Step 4: Use volunteer signups publicly</h3>
          <p>
            Public volunteer opportunities allow attendees or community members
            to sign up for open needs. This makes it easier to recruit help
            before the event.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Related guide</h5>
            <p className="mb-3">
              Volunteers are especially helpful on event day when attendees need
              support with QR codes, voting, check-in, or directions.
            </p>

            <Link to="/guides/running-event-day" className="btn btn-primary">
              Review Running Event Day
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default VolunteersGuide;